<script>
import Layout from '@layouts/loginLayout.vue'
import { emailChangeConfirmation } from '@src/api/auth'
import router from '@router'
import store from '@state/store'

export default {
  page: {
    title: 'Email Change Confirmation',
    meta: [
      {
        name: 'description',
        content: 'The Email Change Confirmation page.',
      },
    ],
  },
  components: { Layout },
  data() {
    this.emailChangeConfirmation()
    return {
      initialLoading: true,
      successfully: false,
      loggedIn: store.getters['auth/loggedIn'],
    }
  },
  methods: {
    async emailChangeConfirmation() {
      try {
        await emailChangeConfirmation({
          id: this.$route.params.id,
          hash: this.$route.params.hash,
        }).then(async () => {
          if (this.loggedIn) {
            await router.push({ name: 'myInfo' })
            this.toastSuccess()
          } else {
            this.initialLoading = false
            this.successfully = true
          }
        })
      } catch (err) {
        this.initialLoading = false
        this.toastError()
      }
    },

    toastSuccess() {
      const toastMessage = 'Personal email change has been confirmed!'
      this.$bvToast.toast(toastMessage, {
        toaster: 'b-toaster-bottom-center',
        toastClass: 'toast-success',
        noAutoHide: true,
      })
    },

    toastError() {
      const toastMessage = 'This link was expired!'
      this.$bvToast.toast(toastMessage, {
        toaster: 'b-toaster-bottom-center',
        toastClass: 'toast-error',
        noAutoHide: true,
      })
    },
  },
}
</script>

<template>
  <Layout>
    <form>
      <BaseIcon v-if="initialLoading" name="spinner" spin />

      <div v-else>
        <h2 v-if="successfully" class="motto-blue-text mb-35">Personal email change has been confirmed!</h2>

        <BaseLink v-if="loggedIn" :to="{ name: 'myInfo' }">
          <BaseButton type="button">
            <span>Go to Profile Page</span>
          </BaseButton>
        </BaseLink>

        <BaseLink v-else :to="{ name: 'home' }">
          <BaseButton type="button">
            <span>Go to Home Page</span>
          </BaseButton>
        </BaseLink>
      </div>
    </form>
  </Layout>
</template>
